import { jsx as _jsx } from "react/jsx-runtime";
export default function FilterIcon() {
    return (_jsx("svg", { width: "15", height: "10", viewBox: "0 0 15 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M6 9.5V8H9V9.5H6ZM3 5.75V4.25H12V5.75H3ZM0.75 2V0.5H14.25V2H0.75Z", fill: "#123750", "fill-opacity": "0.8" }) }));
}
